import type { FilterDefinition, FilterHandler } from '../engine/types';
import { FilterId, FilterType, type StaticListFilter } from '../types/filters';

export const PUBLIC_OPTIONS = [
  { value: 'true', label: 'True', limit: 1 },
  { value: 'false', label: 'False', limit: 1 },
];

export const publicDefinition: FilterDefinition<StaticListFilter> = {
  id: FilterId.PUBLIC,
  name: 'Public',
  selections: [],
  type: FilterType.STATIC_LIST,
  isVisible: true,
};

export const publicHandler: FilterHandler<StaticListFilter> = {
  isActive(currentFilterState: StaticListFilter) {
    return currentFilterState.selections.length > 0;
  },
  isDefault(currentFilterState: StaticListFilter) {
    return currentFilterState.selections.length === 0;
  },
  getEffectiveFilter(currentFilterState: StaticListFilter) {
    return { ...currentFilterState };
  },
};
